import script from "./ProvidersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvidersView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__